module.exports = {
      id: "ic-dtrended-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#ic-dtrended-usage",
      toString: function () {
        return this.url;
      }
    }